import { DeepPartial } from '@apollo/client/utilities'
import { AttendanceEditTimesheetRequestRequestTypeEnum } from 'generated/resources/datatable.graphql'
import { AttendanceEditTimesheetRequestApprovableMetadataFragment } from 'generated/resources/graphql'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

const REQUEST_TYPES_TEXT: Record<AttendanceEditTimesheetRequestRequestTypeEnum, () => string> = {
  create_shift: () =>
    i18n.t('tasks.approvals.attendance_edit_timesheet_request.fields.request_type_create'),
  update_shift: () =>
    i18n.t('tasks.approvals.attendance_edit_timesheet_request.fields.request_type_update'),
  delete_shift: () =>
    i18n.t('tasks.approvals.attendance_edit_timesheet_request.fields.request_type_delete'),
}

export const getAttendanceEditTimesheetRequestMetadata = (
  data: DeepPartial<AttendanceEditTimesheetRequestApprovableMetadataFragment>
) => {
  const date = data.attendanceShiftDate
    ? stringToDate(data.attendanceShiftDate, 'backend_datetime')
    : undefined
  const displayDate = date ? i18nDateToString(date, 'ui_dmy_long') : ''

  const requestTypeText = data.requestType ? REQUEST_TYPES_TEXT[data.requestType]() : undefined

  return [requestTypeText, displayDate].filter(Boolean)
}
